import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { adminApi } from '../../lib/http';
import { PortalButton, PortalCard, PortalInput } from '../../components/portal/PortalElements';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    adminApi
      .get('/admin/auth/me')
      .then(() => navigate('/admin/dashboard', { replace: true }))
      .catch(() => undefined);
  }, [navigate]);

  async function handleSubmit(event) {
    event.preventDefault();
    setLoading(true);
    setError('');

    try {
      await adminApi.post('/admin/auth/login', { email, password });
      await adminApi.get('/admin/auth/me');
      toast.success('Admin session started.');
      navigate(params.get('redirect') || '/admin/dashboard', { replace: true });
    } catch (requestError) {
      setError(
        requestError.response?.status === 401
          ? 'Invalid admin credentials.'
          : requestError.message || 'Unable to sign in right now.',
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="portal-login-page">
      <PortalCard className="portal-login-card">
        <p className="portal-kicker">Admin access</p>
        <h2>Sign in to the admin panel</h2>
        {/* <p>Use the hosted backend session to manage bookings, closures, staff, and check-ins.</p> */}
        <form className="portal-form" onSubmit={handleSubmit}>
          <PortalInput
            label="Email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="admin@example.com"
            required
          />
          <PortalInput
            label="Password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            placeholder="Password"
            required
          />
          {error ? <div className="portal-error">{error}</div> : null}
          <PortalButton type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Login'}
          </PortalButton>
        </form>
      </PortalCard>
    </main>
  );
}
